import { TCString } from "@iabtcf/core/lib/TCString";
import { extendAlmaGlobal } from "../../utils";
import Service from "../service";
import { getConsentStringPrivate, getNonTCFVendorConsentsPrivate, getPublisherConsentsPrivate, getVendorConsentsPrivate, } from "./alma-api";
function deferredPromise(resolveWith) {
    let res;
    const p = new Promise((resolve) => {
        if (typeof resolveWith === "function") {
            res = () => {
                resolve(resolveWith());
            };
        }
        else {
            res = resolve;
        }
    });
    Object.defineProperty(p, "resolve", {
        value: res,
    });
    return p;
}
class AlmaCmpService extends Service {
    constructor(config, context) {
        super("AlmaCmp", context);
        this.cmpReleased = false;
        this.requestsQueue = [];
        this.configuration = config;
        extendAlmaGlobal({
            getPublisherConsents: this.getPublisherConsents.bind(this),
            getVendorConsents: this.getVendorConsents.bind(this),
            getNonTCFVendorConsents: this.getNonTCFVendorConsents.bind(this),
            getConsentString: this.getConsentString.bind(this),
            optin: false,
        }, "cmpV2");
    }
    // Eslint false positive
    // eslint-disable-next-line consistent-return
    wrapInternalApi(getter, callback) {
        if (typeof callback === "function") {
            try {
                const c = getter();
                callback(c);
            }
            catch (e) {
                this.logger.logWarn(`Consent is not set: ${e}`);
                callback({ error: "consent not set" });
            }
        }
        else {
            if (!this.cmpReleased) {
                this.logger.logInfo(`Consent is not ready yet, queueing request`);
                const p = deferredPromise(getter);
                this.requestsQueue.push(p);
                return p;
            }
            return new Promise((resolve, reject) => {
                try {
                    const consents = getter();
                    resolve(consents);
                }
                catch (e) {
                    this.logger.logError(`Unable to get consent from Gravito global: ${e}`);
                    reject(new Error("consent not set"));
                }
            });
        }
    }
    getPublisherConsents(callback) {
        return this.wrapInternalApi(getPublisherConsentsPrivate.bind(this), callback);
    }
    getVendorConsents(arg0, arg1) {
        return this.wrapInternalApi(() => {
            const filterParam = arg1 ?? arg0;
            if (typeof filterParam === "object" && filterParam.type) {
                const consents = getVendorConsentsPrivate();
                if (filterParam.type === "consented") {
                    const filtered = Object.entries(consents).reduce((arr, curr) => {
                        if (curr[1] === true) {
                            return [...arr, Number.parseInt(curr[0], 10)];
                        }
                        return arr;
                    }, []);
                    return filtered;
                }
                if (filterParam.type === "both") {
                    const filtered = {
                        true: Object.entries(consents).reduce((arr, curr) => {
                            if (curr[1] === true) {
                                return [...arr, Number.parseInt(curr[0], 10)];
                            }
                            return arr;
                        }, []),
                        false: Object.entries(consents).reduce((arr, curr) => {
                            if (curr[1] === false) {
                                return [...arr, Number.parseInt(curr[0], 10)];
                            }
                            return arr;
                        }, []),
                    };
                    return filtered;
                }
            }
            return getVendorConsentsPrivate();
        }, arg0);
    }
    getNonTCFVendorConsents(arg0, arg1) {
        return this.wrapInternalApi(() => {
            const filterParam = arg1 ?? arg0;
            if (typeof filterParam === "object" && filterParam.type) {
                const consents = getNonTCFVendorConsentsPrivate();
                if (filterParam.type === "consented") {
                    const filtered = Object.entries(consents).reduce((arr, curr) => {
                        if (curr[1] === true) {
                            return [...arr, Number.parseInt(curr[0], 10)];
                        }
                        return arr;
                    }, []);
                    return filtered;
                }
                if (filterParam.type === "both") {
                    const filtered = {
                        true: Object.entries(consents).reduce((arr, curr) => {
                            if (curr[1] === true) {
                                return [...arr, Number.parseInt(curr[0], 10)];
                            }
                            return arr;
                        }, []),
                        false: Object.entries(consents).reduce((arr, curr) => {
                            if (curr[1] === false) {
                                return [...arr, Number.parseInt(curr[0], 10)];
                            }
                            return arr;
                        }, []),
                    };
                    return filtered;
                }
            }
            return getNonTCFVendorConsentsPrivate();
        }, arg0);
    }
    async getConsentString(callback) {
        let cs;
        try {
            cs = await getConsentStringPrivate();
        }
        catch (e) {
            this.logger.logError(`Error getting consent string from tcfapi: ${e}`);
        }
        return this.wrapInternalApi(
        // TODO: Fix later. Force object as retval because tcfapi throws if there is nothing to return
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        () => cs || { error: "consent not set" }, callback);
    }
    parseConsentDataString(consentDataString) {
        this.logger.logInfo(`Trying to parse consent data string as JSON`);
        if (!consentDataString) {
            this.logger.logInfo(`Consent string is empty`);
            return undefined;
        }
        let consentDataObject;
        try {
            consentDataObject = JSON.parse(consentDataString);
        }
        catch (e) {
            this.logger.logError(`Unable to parse consent data string: ${e}`);
            return undefined;
        }
        this.logger.logInfo(`Decoding consent data object ${JSON.stringify(consentDataObject, null, 2)}`);
        try {
            const decodedConsent = TCString.decode(consentDataObject.TCString);
            return decodedConsent;
        }
        catch (e) {
            this.logger.logError(`Unable to decode consent string: ${e}`);
            return undefined;
        }
    }
}
export default AlmaCmpService;
//# sourceMappingURL=almacmp.js.map